import { render, staticRenderFns } from "./commerceClassroomList.vue?vue&type=template&id=3119be44&scoped=true&"
import script from "./commerceClassroomList.vue?vue&type=script&lang=js&"
export * from "./commerceClassroomList.vue?vue&type=script&lang=js&"
import style0 from "./commerceClassroomList.vue?vue&type=style&index=0&id=3119be44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119be44",
  null
  
)

export default component.exports